import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { ReactComponent as CoupleIcon } from "../../../../assets/Icons/couple.svg";
import { useUserProfile } from "../../../../contexts/UserProfile";

const ClientTypes = () => {
  const { data } = useUserProfile();
  return (
    <Box
      sx={{
        p: 1.5,
        border: "1px solid",
        borderColor: "border.main",
        borderRadius: 2,
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          mb: 1,
        }}
      >
        <CoupleIcon />
        <Typography variant="h5" fontWeight={400}>
          Client Types
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 0.5,
          alignItems: "center",
        }}
      >
        {data.client_types?.map((item, index, array) => (
          <Typography
            key={item?.id || index}
            component="span"
            variant="body1"
            sx={{
              whiteSpace: "nowrap", // Prevent line breaks within each item
            }}
          >
            {item?.name}
            {index < array.length - 1 ? "," : ""}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default ClientTypes;
